module.exports = require("core-js/library/fn/date/now");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/date/now.js
// module id = 514
// module chunks = 0